module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FREE_XP_AND_CREW_XP.b1fce7db.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FREE_XP_AND_CREW_XP.png
// module id = 1286
// module chunks = 16